var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoviesFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 26 26",
    style: {
      enableBackground: "new 0 0 26 26"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#2FDA7B;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23,0H3C1.3,0,0,1.3,0,3v20c0,1.7,1.3,3,3,3h20c1.7,0,3-1.3,3-3V3C26,1.3,24.7,0,23,0z M18.5,13.4 c-0.1,0.1-0.2,0.2-0.3,0.3l-8,4.8c-0.1,0.1-0.3,0.1-0.4,0.1c-0.4,0-0.8-0.4-0.8-0.8V8.2c0-0.4,0.4-0.8,0.8-0.8c0.1,0,0.3,0,0.4,0.1 l8,4.8C18.6,12.5,18.7,13,18.5,13.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoviesFilled);
export default __webpack_public_path__ + "static/media/Movies-filled.4fb1808f050362f701087fa84f5479a9.svg";
export { ForwardRef as ReactComponent };